// Author Lin
// Date 2023-08-11 08:42:03

class SithMesPrdKamChange {
constructor({
        id = null,
        changeType = '',
        changeReason = '',
        changeDescription = '',
        projectKamId = '',
        materialNumber = '',
        makeOrBuy = '',
        doConfirm = '',
        doConfirmTime = '',
        mpConfirm = '',
        mpConfirmTime = '',
        prdConfirm = '',
        prdConfirmTime = '',
        contractModifier = '',
        contractModifyTime = '',
        status = '',
        workOrderCode = '',
        remark = '',
        attachmentIds = '',
        attachmentIdsList = ''}
= {}) {
    this.id = id;
    this.changeType = changeType;
    this.changeReason = changeReason;
    this.changeDescription = changeDescription;
    this.projectKamId = projectKamId;
    this.materialNumber = materialNumber;
    this.makeOrBuy = makeOrBuy;
    this.doConfirm = doConfirm;
    this.doConfirmTime = doConfirmTime;
    this.mpConfirm = mpConfirm;
    this.mpConfirmTime = mpConfirmTime;
    this.prdConfirm = prdConfirm;
    this.prdConfirmTime = prdConfirmTime;
    this.contractModifier = contractModifier;
    this.contractModifyTime = contractModifyTime;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.remark = remark;
    this.attachmentIds = attachmentIds;
    this.attachmentIdsList = attachmentIdsList;
}
}

function newEntity() {
return new SithMesPrdKamChange();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'changeType',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.changeType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'KAM变更' },
                            { value: '5', text: '工程变更' }
            ]
        }
        },
        {
        key: 'changeReason',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.changeReason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'changeDescription',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.changeDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectKamId',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.projectKamId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.network',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cid',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.cid',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentIdsList',
        label: 'label.sith.prd.sithMesPrdKamChange.grid.attachmentIdsList',
        sortable: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    workOrderCodeFilter : '',
    statusNameFilter : '',
    changeTypeFilter : '',
    changeReasonFilter : '',
    changeDescriptionFilter : '',
    projectKamIdFilter : '',
    projectCodeFilter : '',
    materialNumberFilter : '',
    makeOrBuyFilter : '',
    createdByFilter : '',
    createdByNameFilter : '',
    cidFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusNameFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.statusName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'changeTypeFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.changeType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: 'KAM变更' },
                { value: '5', text: '工程变更' }
            ]
        }
        },
        {
        key: 'changeReasonFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.changeReason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'changeDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.changeDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialNumberFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.createdByName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"createdBy": "loginName"}'
                }
        },
        {
        key: 'cidFilter',
        label: 'label.sith.prd.sithMesPrdKamChange.filter.cid',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'changeType',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.changeType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: 'KAM变更' },
                { value: '5', text: '工程变更' }
            ]
        }
        },
        {
        key: 'changeReason',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.changeReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'changeDescription',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.changeDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectKamId',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.projectKamId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdProjectKam'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'makeOrBuy',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.makeOrBuy',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: 'MAKE' },
                { value: '1', text: 'BUY' }
            ]
        }
        },
        {
        key: 'doConfirm',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.doConfirm',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'doConfirmTime',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.doConfirmTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mpConfirm',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.mpConfirm',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'mpConfirmTime',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.mpConfirmTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdConfirm',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.prdConfirm',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'prdConfirmTime',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.prdConfirmTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'contractModifier',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.contractModifier',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'contractModifyTime',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.contractModifyTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentIdsList',
        label: 'label.sith.prd.sithMesPrdKamChange.entity.attachmentIds',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachmentIds'
                }
        }
]

export {SithMesPrdKamChange, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
